<template>
  <b-modal
    id="answer-modal"
    v-model="show"
    size="lg"
    @close="onCancel"
    no-close-on-backdrop
    hide-header-close
    no-close-on-esc
  >
    <template v-slot:modal-title>Message Template Updates</template>
    <div class="my-2">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Change Set</th>
            <th scope="col" class="w-25">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in changeList" :key="index">
            <th scope="row" v-text="index + 1"></th>
            <td v-if="item.attr">
              <span class="font-weight-bold">Upload: </span>
              {{
                item.attr.value.file_content
                  ? item.attr.value.file_content.name
                  : item.attr.value.content
              }}
            </td>
            <td v-else v-text="item.type + ' Message'"></td>
            <td class="w-25">
              <span class="text-warning" v-if="item.status == 'Pending'">
                <em class="fa fa-asterisk mr-2"></em>{{ item.status }}
              </span>
              <span class="text-info" v-if="item.status == 'In-Progress'">
                <em class="fa fa-gear fa-spin mr-2"></em>{{ item.status }}
              </span>
              <span class="text-success" v-if="item.status == 'Success'">
                <em class="fa fa-check-circle mr-2"></em>{{ item.status }}
              </span>
              <span class="text-danger" v-if="item.status == 'Failed'">
                <em class="fa fa-times-circle mr-2"></em>{{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>
<script>
import MessageApi from "../../../apis/MessagesApi";
import { useManageAttributes } from "../../../stores/manage-attributes";
export default {
  props: {
    messageId: String | Number,
  },
  data() {
    return {
      cloning: false,
      show: false,
      createdMessageId: null,
      changeList: [],
      resolve: null,
      reject: null,
      instanceId: window.Laravel.selected_instance
        ? window.Laravel.selected_instance.id
        : null,
      eTag: null,
      useManageAttributes: useManageAttributes(),
    };
  },
  computed: {
    form() {
      return this.useManageAttributes.getForm;
    },
    messageSetupId() {
      return this.messageId || this.createdMessageId;
    },
    templates() {
      return this.useManageAttributes.templates;
    },
  },
  methods: {
    clone() {
      this.disableClose = true;
      this.show = true;
      this.cloning = true;
      this.changeList = this.cloneChangeList();
      this.eTag = null;
      this.saveMessage();
    },
    open() {
      this.disableClose = true;
      this.show = true;
      this.cloning = false;
      this.changeList = this.findChangeList();
      this.eTag = null;
      let headers = this.useManageAttributes.headers;
      if (headers && headers["ETag"] && headers["ETag"].length > 0) {
        this.eTag = headers["ETag"][0];
      }
      this.saveMessage();
    },
    approvalProcess() {
      return (
        window.Laravel.selected_instance.hasOwnProperty("attributes") &&
        window.Laravel.selected_instance.attributes.hasOwnProperty(
          "messageTemplate"
        ) &&
        window.Laravel.selected_instance.attributes.messageTemplate.hasOwnProperty(
          "approvalProcessEnabled"
        ) &&
        window.Laravel.selected_instance.attributes.messageTemplate
          .approvalProcessEnabled
      );
    },
    cloneChangeList() {
      let changeList = [];
      changeList.push({
        type: "Clone",
        status: "Pending",
      });
      this.form.attributesList.forEach((attr, index) => {
        if (attr.dataType == "Image" || attr.dataType == "File") {
          changeList.push({
            index: index,
            attr: attr,
            status: "Pending",
          });
        }
      });
      // To track the final Message Update.
      changeList.push({
        type: "Update",
        status: "Pending",
      });
      return changeList;
    },
    findChangeList() {
      let changeList = [];
      if (!this.messageId) {
        // For new message templates, create the message first.
        changeList.push({
          type: "Create",
          status: "Pending",
        });
      }
      this.form.attributesList.forEach((attr, index) => {
        if (this.isFileUpload(attr)) {
          changeList.push({
            index: index,
            attr: attr,
            status: "Pending",
          });
        }
      });
      changeList.push({
        type: "Update",
        status: "Pending",
      });
      return changeList;
    },
    isFileUpload(attr) {
      return (
        (attr.dataType == "Image" || attr.dataType == "File") &&
        attr.value &&
        attr.value.file_content instanceof File
      );
    },
    onCancel() {
      this.show = false;
      this.disableClose = false;
    },
    saveMessage() {
      const start = async () => {
        if (!this.messageId || this.cloning) {
          // Create the Message First.
          this.createMessage(this.changeList[0])
            .then((r) => {
              this.form.id = r.data.result.id;
              //this.form.type = this.form.template.id;
              this.changeList[0].status = "Success";
              this.createdMessageId = r.data.result.id;
              this.useManageAttributes.updateHeaders(r.headers);
              let headers = this.useManageAttributes.headers;
              if (headers && headers["ETag"] && headers["ETag"].length > 0) {
                this.eTag = headers["ETag"][0];
              }
              this.updateMessageData();
            })
            .catch((e) => {
              this.changeList[0].status = "Failed";
              this.useManageAttributes.updateStates({
                saving: false,
              });
              if (e.response.status == 409) {
                this.$toast.error("Error", this.$t("messages.already_exists"));
                this.useManageAttributes.setErrorMessage(
                  this.$t("messages.already_exists")
                );
              } else if (e.response.status == 400) {
                this.$toast.error("Error", e.response.data.data.detail);
                this.useManageAttributes.setErrorMessage(
                  e.response.data.data.detail
                );
              } else if (e.response.status == 422) {
                let err = AttributeUtils.convertToErrorMessage(
                  e.response.data.errors
                );
                this.$toast.error("Error", err);
                this.useManageAttributes.setErrorMessage(err);
              } else {
                this.$toast.error("Error", this.$t("messages.create_failed"));
                this.useManageAttributes.setErrorMessage(
                  this.$t("messages.create_failed")
                );
              }

              if (this.cloning) {
                window.location.reload();
              } else {
                // Close the modal
                this.show = false;
              }
            });
        } else {
          this.updateMessageData();
        }
      };
      start();
    },
    async createMessage(item) {
      item.status = "In-Progress";
      // Do not send file attributes on create yet.
      let attributes = {};
      Object.keys(this.form.attributes).forEach((key) => {
        if (
          this.form.attributes[key] &&
          (!this.form.attributes[key].file_content ||
            !(this.form.attributes[key].file_content instanceof File))
        ) {
          attributes[key] = this.form.attributes[key];
        }
      });
      this.useManageAttributes.updateValue({
        key: "isActive",
        value: value,
      });
      let payload = {
        payload: {
          name: this.form.name,
          description: this.form.description,
          isActive: this.form.isActive,
          status: this.approvalProcess() ? "DRAFT" : "APPROVED",
          attributes: this.form.attributes,
        },
      };

      if (this.form.id) {
        payload.id = this.form.id;
      }

      return await MessageApi.create(payload, this.instanceId);
    },
    async updateMessageData() {
      await this.asyncForEach(this.changeList, async (item) => {
        if (item.attr) {
          await this.uploadDocument(item);
        } else if (item.type == "Update") {
          await this.updateMessage(item);
        }
      });
    },
    async uploadDocument(item) {
      item.status = "In-Progress";
      try {
        await this.uploadDocumentFromFile(item);
      } catch (error) {
        item.status = "Failed";
        this.$toast.error("Error", this.$t("messages.upload_failed"));
      }
    },
    async uploadDocumentFromFile(item) {
      let formData = new FormData();
      formData.append("file", item.attr.value.file_content);
      formData.append("eTag", this.eTag);
      let response = await MessageApi.uploadFile(
        formData,
        this.instanceId,
        this.messageSetupId
      );
      let data = response.data.data.data;
      item.attr.value.content = data.result.resourceUrl;
      item.attr.value.contentkey = data.result.resourceKey;
      item.status = "Success";
    },
    async updateMessage(item) {
      item.status = "In-Progress";
      let attributes = _.cloneDeep(this.form.attributes);
      delete attributes.type;
      delete attributes.message;
      delete attributes.messageType;
      delete attributes.gcma;
      Object.keys(attributes).forEach((key) => {
        if (
          attributes[key].file_content &&
          attributes[key].file_content instanceof File
        ) {
          delete attributes[key].file_content;
        }
      });
      let payload = {
        name: this.form.name,
        description: this.form.description,
        isActive: this.form.isActive,
        attributes: {
          assets: attributes.assets ?? attributes,
          message: this.form.message,
          type: this.form.type,
          messageType: this.form.messageType,
          gcma: this.form.gcma,
        },
      };

      payload = {
        payload: payload,
      };
      MessageApi.update(payload, this.instanceId, this.messageSetupId)
        .then((r) => {
          item.status = "Success";
          this.useManageAttributes.updateStates({
            showSuccess: true,
          });
          this.$toast.success(
            "Success",
            this.$t("messages.saved_successfully")
          );
          this.useManageAttributes.initialize(r.data);
          this.useManageAttributes.updateHeaders(r.headers);
          this.useManageAttributes.updateStates({
            saving: false,
            showSuccess: true,
          });
          if (this.cloning) {
            window.location.reload();
          } else if (this.messageId) {
            // Close the modal
            this.show = false;
          } else {
            //If the update happened as part of create screen, redirect to edit page.
            window.location.href = this.$routes("program.messages.edit", {
              id: this.createdMessageId,
            });
          }
        })
        .catch((e) => {
          let errorMessage = this.$t("commons.failed");
          item.status = "Failed";
          this.useManageAttributes.updateStates({
            saving: false,
          });
          if (e.response.status == 412) {
            errorMessage = this.$t("commons.optimistic_lock");
            this.useManageAttributes.setErrorMessage(errorMessage);
            this.invalid = true;
          } else if (e.response.status == 400) {
            errorMessage = e.response.data.data.detail;
            this.useManageAttributes.setErrorMessage(errorMessage);
          }
          this.$toast.error("Error", errorMessage);
          // Close the modal
          this.show = false;
        });
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
  },
};
</script>
